import { connectedStore } from '../../store';
import actions from '../actions';

const createMediaGalleryAssets = (data, config) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.createMediaGalleryAssets(data, config, resolve, reject));
  });

export default createMediaGalleryAssets;
